import React from "react";

const SaleRateKharifCropsSeeds = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Sale Rate of Kharif Seeds - Crops</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        style={{ textAlign: "justify" }}
      >
        <div className="row mb-1 justify-content-between">
          <div className="col-lg-12 mb-1">
            <h6>Our seed remains available easily at:</h6>

            <ol>
              <li>HSDC sale counters.</li>
              <li>
                Farmers&#39; Service Centres of Haryana Agro Industries
                Corporation.
              </li>
              <li>Mini Banks.</li>
              <li>Co-op. Societies of HAFED.</li>
              <li>Farmers&#39; Service Centres of HLRDC.</li>
            </ol>

            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th colspan="6">Sale Rate for Summer / Kharif 2025</th>
                  </tr>
                  <tr>
                    <th rowspan="2">Sr.No.</th>
                    <th rowspan="2">Crop</th>
                    <th rowspan="2">Variety</th>
                    <th colspan="3"> Rate Rs. per Quintal</th>
                  </tr>
                  <tr>
                    <th>Full Sale Rate</th>
                    <th>Subsidy</th>
                    <th>Subsidized Sale Rate to farmerds</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td rowspan="2">1</td>
                    <td rowspan="2">Moong</td>
                    <td rowspan="">MH-421</td>
                    <td rowspan="">17000</td>
                    <td rowspan="">2500</td>
                    <td rowspan="">14500</td>
                  </tr>

                  <tr>
                    <td rowspan="">MH-1142</td>
                    <td rowspan="">17000</td>
                    <td rowspan="">5000</td>
                    <td rowspan="">12000</td>
                  </tr>
                  <tr>
                    <td rowspan="8">2</td>
                    <td rowspan="8">Paddy</td>
                    <td rowspan="">PR-126</td>
                    <td rowspan="">5700</td>
                    <td rowspan="">1000</td>
                    <td rowspan="">4700</td>
                  </tr>
                  <tr>
                    <td rowspan="">PR-114</td>
                    <td rowspan="">4700</td>

                    <td rowspan="">-</td>
                    <td rowspan="">4700</td>
                  </tr>
                  <tr>
                    <td rowspan="">PB-1509, PB-01</td>
                    <td rowspan="">5100</td>
                    <td rowspan="">-</td>
                    <td rowspan="">5100</td>
                  </tr>
                  <tr>
                    <td rowspan="">PB-1692, PB-1886, PB-1847</td>
                    <td rowspan="">6100</td>
                    <td rowspan="">1000</td>
                    <td rowspan="">5100</td>
                  </tr>
                  <tr>
                    <td rowspan="">PB-1718, PB-1885, PB-1979</td>
                    <td rowspan="">8500</td>
                    <td rowspan="">1000</td>
                    <td rowspan="">7500</td>
                  </tr>
                  <tr>
                    <td rowspan="">PB-1121</td>
                    <td rowspan="">7500</td>
                    <td rowspan="">-</td>
                    <td rowspan="">7500</td>
                  </tr>
                  <tr>
                    <td rowspan="">CSR-30</td>
                    <td rowspan="">12300</td>
                    <td rowspan="">-</td>
                    <td rowspan="">12300</td>
                  </tr>
                  <tr>
                    <td rowspan="">PR-128</td>
                    <td rowspan="">5700</td>
                    <td rowspan="">1000</td>
                    <td rowspan="">4700</td>
                  </tr>

                  <tr>
                    <td rowspan="">3</td>
                    <td rowspan="">Gaur</td>
                    <td rowspan="">HG-365, HG-563, HG-2-20</td>
                    <td rowspan="">9700</td>
                    <td rowspan="">-</td>
                    <td rowspan="">9700</td>
                  </tr>
                  <tr>
                    <td rowspan="">4</td>
                    <td rowspan="">Arhar</td>
                    <td rowspan="">PADU-16</td>
                    <td rowspan="">14500</td>
                    <td rowspan="">5000</td>
                    <td rowspan="">9500</td>
                  </tr>
                  <tr>
                    <td rowspan="">5</td>
                    <td rowspan="">Jowar</td>
                    <td rowspan="">CSF-24 MF (Packing Size-5Kg)</td>
                    <td rowspan="">330/- (per packet)</td>
                    <td rowspan="">-</td>
                    <td rowspan="">330/- (per packet)</td>
                  </tr>
                  <tr>
                    <td rowspan="">6</td>
                    <td rowspan="">Fodder Maize</td>
                    <td rowspan="">African Tail (Packing Size-5Kg)</td>
                    <td rowspan="">316/- (per packet)</td>
                    <td rowspan="">-</td>
                    <td rowspan="">316/- (per packet)</td>
                  </tr>
                  <tr>
                    <td rowspan="">7</td>
                    <td rowspan="">Fodder Bajra</td>
                    <td rowspan="">FBC-16 (Packing Size-2Kg)</td>
                    <td rowspan="">84/- (per packet)</td>
                    <td rowspan="">-</td>
                    <td rowspan="">84/- (per packet)</td>
                  </tr>
                  <tr>
                    <td rowspan="">8</td>
                    <td rowspan="">Bt. Cotton</td>
                    <td rowspan="">
                      RCH-776, RCH-773, RCH-951, RCH-846, RCH-926 (Packing
                      Size-475 gm)
                    </td>
                    <td rowspan="">890/- (per packet)</td>
                    <td rowspan="">-</td>
                    <td rowspan="">890/- (per packet)</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaleRateKharifCropsSeeds;
